import Instance from '../../../Axios';

const AdicionarApartamento = (ydata, fotoSelected) => async (dispatch) => {
  const formdata = new FormData();

  formdata.append('ydata', JSON.stringify(ydata));
  formdata.append('files', fotoSelected);

  console.log([...formdata]);

  await Instance()
    .post('/backend/apartamentos', formdata)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'POST_APARTAMENTOS', payload: data });
      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
        console.log(err);
      }
    });
};

export default AdicionarApartamento;
